import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText, FadeView, LoadingDots, TextLink } from '@sg/garnish';

import { useContactUsHandler } from '../../../../hooks';

/**
 * Need to cancel your order? Contact us ⋯
 */
export const OrderStatusCancellationOption = () => {
  const { formatMessage } = useIntl();
  // @ts-expect-error - handlingContactUs no longer returned by useContactUsHandler
  const { handleContactUs, handlingContactUs } = useContactUsHandler('order-status');

  const label = formatMessage(messages.orderStatusInfoCancellationOption);
  const highlight = formatMessage(messages.orderStatusInfoCancellationHighlight);

  return (
    <View style={styles.optionContainer}>
      <BodyText size={3}>
        <Text>{label}</Text>
        <TextLink onPress={handleContactUs}>{highlight}</TextLink>
      </BodyText>

      <FadeView show={handlingContactUs} style={styles.loadingIcon}>
        <LoadingDots />
      </FadeView>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  orderStatusInfoCancellationOption: {
    defaultMessage: 'Need to cancel your order? ',
    description: 'Order Status Info | Cancellation Option',
  },
  orderStatusInfoCancellationHighlight: {
    defaultMessage: 'Contact us',
    description: 'Order Status Info | Cancellation Highlight',
  },
});

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  optionContainer: {
    flexDirection: 'row',
    marginTop: theme.spacing['4'],
  },
  loadingIcon: {
    marginLeft: theme.spacing['2'],
  },
});
